import { render, staticRenderFns } from "./value-column.vue?vue&type=template&id=74ec0f5d&"
import script from "./value-column.vue?vue&type=script&lang=js&"
export * from "./value-column.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports